import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { catchError, of } from 'rxjs';

import { environment } from '../../environments/environment';
import { Booking, DashboardStats, DemoRequest, Locker, User } from '../models/domain.models';
import { mockBookings, mockLockers, mockStats, mockUser } from './mock-data';

const API_URL = environment.apiUrl;

@Injectable({ providedIn: 'root' })
export class ApiService {
  private readonly http = inject(HttpClient);

  login(email: string, password: string) {
    return this.http.post<{ access_token: string; user: User }>(`${API_URL}/auth/login`, { email, password }).pipe(
      catchError(() => of({ access_token: 'demo-token', user: mockUser }))
    );
  }

  register(payload: Partial<User> & { password: string }) {
    return this.http.post<{ access_token: string; user: User }>(`${API_URL}/auth/register`, payload).pipe(
      catchError(() => of({ access_token: 'demo-token', user: { ...mockUser, ...payload, id: 99, created_at: new Date().toISOString() } as User }))
    );
  }

  createDemoRequest(payload: DemoRequest) {
    return this.http.post(`${API_URL}/demo-requests`, payload).pipe(catchError(() => of({ id: 1, ...payload })));
  }

  getLockers() {
    return this.http.get<Locker[]>(`${API_URL}/lockers`).pipe(catchError(() => of(mockLockers)));
  }

  getBookings() {
    return this.http.get<Booking[]>(`${API_URL}/bookings`).pipe(catchError(() => of(mockBookings)));
  }

  getAdminStats() {
    return this.http.get<DashboardStats>(`${API_URL}/stats/admin`).pipe(catchError(() => of(mockStats)));
  }
}
